import { createContext, useState } from "react";

export const InboxMessageContext = createContext<IInboxMessageContext | undefined>(undefined);

export interface IInboxMessageContext {
    unreadInboxMessage: number | null;
    setUnreadInboxMessage: any
}

export const InboxMessageProvider = ({ children }: any) => {

    const [unreadInboxMessage, setUnreadInboxMessage] = useState<number | null>(0);

    return (
        <InboxMessageContext.Provider value={{ unreadInboxMessage, setUnreadInboxMessage }}>
            {children}
        </InboxMessageContext.Provider>
    );
}